module.exports = __webpack_public_path__ + "52c201b92115f73ef7e7bbde43d09ee1.gif";